import _RentalDepositApprovalService from "../services/rental-deposit-approval-service";
import { IRentalDepositApprovalService } from "../types/services/rental-deposit-approval-service";

const instance = new _RentalDepositApprovalService();

const RentalDepositApprovalService: IRentalDepositApprovalService = instance;

export default RentalDepositApprovalService;
